// extracted by mini-css-extract-plugin
export default {"changeLink":"DQ-z","disabled":"EQ-z","inline":"FQ-z"};